import { render, staticRenderFns } from "./DialogAddPage.vue?vue&type=template&id=02e5422a&"
import script from "./DialogAddPage.vue?vue&type=script&lang=js&"
export * from "./DialogAddPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports